import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { GoogleAnalyticsTracker } from "../../Managers/GoogleAnalyticsTracker";
import { TrackingEvent } from "../../ga/TrackingEvent";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";
import { LS2PAC_Utils } from "../utils/Utils";
import { AccountHolder } from "@tlc/ls2pac/components/Account";

export class GoogleAnalyticsManager {
  constructor(options) {
    //initialize the tracker

    this.googleAnalyticTracker = new GoogleAnalyticsTracker(
      options.trackingCode,
      options.enabled,
      options.variables,
      options.dimensionMap
    );
    this.setupSharedListeners();

    if (this.setupPersonalListeners) {
      this.setupPersonalListeners();
    }
    //can variables be set after
    //can domain be set after?
  }
  trackEResourceClick(action, label, resource) {
    var category = null,
      page = resource.link;
    if (
      resource.eAvailabilities !== undefined &&
      resource.eAvailabilities.length > 0
    ) {
      category = resource.eAvailabilities[0].service;
    } else {
      category = LS2PAC_Utils.getDomainFromURL(resource.link);
    }
    this.googleAnalyticTracker.trackEvent(
      new TrackingEvent(category, action, label)
    );
    this.googleAnalyticTracker.trackPageView(page);
  }
  setupSharedListeners() {
    TLCLogger.log(
      "setting up shared listeners for " +
        this.googleAnalyticTracker.trackingCode
    );
    var _this = this;
    //Search
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (requestEvent) {
        TLCEventManager.addOneTimeListener(
          TLC_CONSTANTS.Events.onPagingModelResponse,
          function (responseEvent) {
            try {
              var searchType = "",
                termInfo = requestEvent.searchString;
              let term;
              if (responseEvent.data.totalHits > 0) {
                term =
                  "SearchResult/" +
                  searchType +
                  "?term=" +
                  termInfo +
                  "&searchType=" +
                  searchType;
              } else {
                term =
                  "OrphanSearch/" +
                  searchType +
                  "/" +
                  termInfo +
                  "?term=" +
                  termInfo +
                  "&searchType=" +
                  searchType;
              }
              TLCLogger.log("onSearch term", term);
              _this.googleAnalyticTracker.trackPageView(term);
            } catch (error) {
              TLCLogger.log(error);
            }
          }
        );
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onShareThis,
      function (event) {
        var userType = "user";
        if (AccountHolder.isConfigAdmin) {
          userType = "admin";
        }
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("List", "Shared", userType)
        );
      }
    );

    //Saved Lists
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRenameListResponse,
      function (event) {
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("List", "Renamed", event.data.resourceListName)
        );
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRemoveItemFromListResponse,
      function (event) {
        //TODO batch or normal?
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent(
            "List",
            "Resources Removed",
            event.data.resourceListName
          )
        );
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onAddToListResponse,
      function (event) {
        //TODO from Results, Details, Copies, etc.
        if (event.data.resourceListId !== undefined) {
          //we are updating
          _this.googleAnalyticTracker.trackEvent(
            new TrackingEvent("List", "Update", event.data.resourceListName)
          );
        } else if (event.data.creationDate) {
          //we are creating
          _this.googleAnalyticTracker.trackEvent(
            new TrackingEvent("List", "Create", event.data.name)
          );
        }
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onDeleteListsResponse,
      function (event) {
        $.each(event.listIds, function (i, listId) {
          _this.googleAnalyticTracker.trackEvent(
            new TrackingEvent("List", "Remove", listId.toString())
          ); //TODO send list name instead of list id
        });
      }
    );

    //Saved Searches
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSaveSearchResponse,
      function (event) {
        //TODO
        //event.data.branchFilters.length*
        //event.data.facetFilters.length*
        //event.data.sortType*
        //event.data.advanced - can be implied from expression
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("Save Search", event.data.expression)
        );
      }
    );

    // Advanced search show is different from subView loading
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onAdvancedSearch,
      function (event) {
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("AdvancedSearch", "open")
        );
        if (event.referrer && event.referrer == "header") {
          _this.googleAnalyticTracker.trackEvent(
            new TrackingEvent("Advanced Search Link", "click", event.view)
          );
        }

        var page = "Advanced Search";
        if (event.view !== undefined) {
          page += "/" + event.view;
        }
        _this.googleAnalyticTracker.trackPageView(page);
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onShowAdvancedSearchSubView,
      function (event) {
        var page = "Advanced Search";
        if (event.viewName !== undefined) {
          page += "/" + event.viewName;
        }
        _this.googleAnalyticTracker.trackPageView(page);
      }
    );

    //Full details show is different from subView loading
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onShowFullDetails,
      function (event) {
        var page = "Full Details";
        if (event.viewName !== undefined) {
          page += "/" + event.viewName;
        }
        _this.googleAnalyticTracker.trackPageView(page);
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onShowFullDetailsSubView,
      function (event) {
        var page = "Full Details";
        if (event.viewName !== undefined) {
          page += "/" + event.viewName;
        }
        _this.googleAnalyticTracker.trackPageView(page);
      }
    );

    //TODO: should tlc track different cat:Request, actions:title/item/booking, label:success/fail
    //_this.googleAnalyticTracker.trackEvent(new TrackingEvent("Request",data.resource.shortTitle));
    //Results paging, flow view paging - include page number, and tab display name - EBSCO, etc. sorting
    //TlcIndigo.eventManager.fireEvent(TlcIndigo.constants.Events.TRACK_EVENT, {listeners:['tlc'], event:new TrackingEvent(databaseConfig.tabDisplayName,"page","From: " + previousPageNumber + " To: " + pageNumber)});
    //TlcIndigo.eventManager.fireEvent(TlcIndigo.constants.Events.TRACK_EVENT, {listeners:['tlc'], event:new TrackingEvent(databaseConfig.tabDisplayName,"sort",sortKey)});
    //TODO TLC only?
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRequest,
      function (event) {
        var contextString = [],
          i = 0;
        contextString[i++] = event.resource.length > 1 ? "Batch" : "";
        contextString[i++] = event.referrer;
        //TODO AllCopies, MoreInfo, Reviews
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("Request", "click", contextString.join(""))
        );
      }
    );

    //TODO context, notification bubble, deep link menu, normal navigation, quick links on summary
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onMyAccount,
      function (event) {
        var page = "My Account";
        if (event.view !== undefined) {
          page += "/" + event.view;
        }
        if (event.subView !== undefined) {
          page += "/" + event.subView;
        }
        _this.googleAnalyticTracker.trackPageView(page);
      }
    );

    //TODO verify this fires in all cases
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase,
      function (event) {
        if (event.databaseKey == "ls2pac") {
          _this.googleAnalyticTracker.trackPageView("SearchResults");
        } else if (event.databaseKey == "ebsco") {
          _this.googleAnalyticTracker.trackPageView("Databases/EBSCO");
        }
      }
    );

    /*
		//TITLE DETAIL SECTION BEGIN
				var showViewHandler = function(event) {
					var directory = "";
					if (event.view.name == "ebscoViewDescription") {
						directory = "Databases/EBSCO/";
					} else if (event.view.name == "galeViewDescription") {
						directory = "Databases/GALE/";
					} else if (event.view.name == "newsBankViewDescription") {
						directory = "Databases/NewsBank/";
					} else {
						directory = "TitleDetail/";
					}
					_this.googleAnalyticTracker.trackPageView(directory + TlcIndigo.formatter.capitalize(event.view.label.toLowerCase()));
				};
		//TITLE DETAIL SECTION END
		*/
    //LOGIN
    //TODO impl
    /*var onLoginErrorCB = function(result) {
			debugLogger.info("LOGIN FAILED");
			debugLogger.info(result);
			_this.googleAnalyticTracker.trackEvent(new TrackingEvent("login","fail"));
		};*/
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLoginResponse,
      function (event) {
        _this.isAdmin = false;
        if (event.success === true) {
          if (AccountHolder.isAdmin) {
            _this.googleAnalyticTracker.setHitDimension("AdminOrUser", "admin");
            _this.googleAnalyticTracker.trackEvent(
              new TrackingEvent("adminlogin", "success")
            );
          } else {
            _this.googleAnalyticTracker.setHitDimension("AdminOrUser", "user");
            _this.googleAnalyticTracker.trackEvent(
              new TrackingEvent("login", "success")
            );
          }
        } else {
          _this.googleAnalyticTracker.setHitDimension("AdminOrUser", null);
          //TODO impl onLoginErrorCB?
        }
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.googleAnalyticTracker.setHitDimension("AdminOrUser", null);
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("logout", event.success ? "success" : "failure")
        );
      }
    );

    //TAGS
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onAddTagResponse,
      function (event) {
        try {
          if (event.success && event.tag.userEntered && !event.tag.blocked) {
            _this.googleAnalyticTracker.trackEvent(
              new TrackingEvent("Tag", event.tag.data, "success")
            );
          } else if (!event.success) {
            _this.googleAnalyticTracker.trackEvent(
              new TrackingEvent("Tag", "Exception", "error")
            );
          }
        } catch (error) {
          TLCLogger.log(error);
        }
      }
    );

    //Forgot Password
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onForgotPasswordResponse,
      function (event) {
        var success = "true";
        if (event.success === false) {
          success = "false";
        }
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("ForgotPassword", success)
        );
      }
    );

    //Forgot Username
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onForgotUsername,
      function (event) {
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("ForgotUsername")
        );
      }
    );

    //Virtual Shelf open event
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onShowVirtualShelf,
      function (event) {
        _this.googleAnalyticTracker.trackPageView("Virtual Shelf");
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetVirtualShelfResources,
      function (event) {
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("VirtualShelf", "navigate", event.type)
        );
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGoToFullDetailsFromVirtualShelf,
      function (event) {
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent("VirtualShelf", "navigate", "coverClick")
        );
        _this.googleAnalyticTracker.trackEvent(
          new TrackingEvent(
            "VirtualShelf",
            "resource",
            event.resource.shortTitle
          )
        );
      }
    );
  }
  setupPersonalListeners() {
    //implement in sub class, throw exception
    TLCLogger.log(
      "setting up personal listeners from base class for " +
        this.googleAnalyticTracker.trackingCode
    );
  }
}
